import { render, staticRenderFns } from "./TheGameWindow.vue?vue&type=template&id=33e0619c&scoped=true&"
import script from "./TheGameWindow.vue?vue&type=script&lang=ts&"
export * from "./TheGameWindow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e0619c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VContainer})
